import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/hooks/useAuth";

const PasswordResetTest = () => {
  const location = useLocation();
  const { user, session, resetPassword } = useAuth();
  const [urlParams, setUrlParams] = useState<Record<string, string>>({});

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramObj: Record<string, string> = {};
    for (const [key, value] of params.entries()) {
      paramObj[key] = value;
    }
    setUrlParams(paramObj);
  }, [location.search]);

  const handleTestReset = async () => {
    const { error } = await resetPassword("test@example.com");

    if (error) {
      console.error("Reset password error:", error);
    } else {
      console.log("Reset password flow started");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center p-4">
      <div className="w-full max-w-2xl">
        <Card className="bg-white/10 backdrop-blur-lg border-white/20">
          <CardHeader>
            <CardTitle className="text-white">Password Reset Debug</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <h3 className="text-white font-semibold mb-2">Current URL:</h3>
              <p className="text-blue-200 text-sm break-all">{window.location.href}</p>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-2">URL Parameters:</h3>
              <pre className="text-blue-200 text-sm bg-black/20 p-2 rounded">
                {JSON.stringify(urlParams, null, 2)}
              </pre>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-2">Current Auth State:</h3>
              <pre className="text-blue-200 text-sm bg-black/20 p-2 rounded">
                {JSON.stringify(
                  {
                    user: user?.email ?? null,
                    userId: user?.id ?? null,
                    hasSessionObject: !!session,
                  },
                  null,
                  2,
                )}
              </pre>
            </div>

            <div className="flex gap-2">
              <Button
                onClick={handleTestReset}
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                Test Reset Password
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PasswordResetTest;
